import { useGetCurrentUserQuery } from "@/setup/frontend/api/apiHooks";

export default function IfAdmin({
	children,
	fallback = null,
}: {
	children: React.ReactNode;
	fallback?: React.ReactNode;
}) {
	const userQuery = useGetCurrentUserQuery();

	if (userQuery.data?.isAdmin) {
		return children;
	} else {
		return fallback ?? null;
	}
}

// export function IfViewPermission({
//   children,
//   viewName,
//   fallback = null,
// }: {
//   viewName: string;
//   children: React.ReactNode;
//   fallback?: React.ReactNode;
// }) {
//   const userQuery = useGetCurrentUserQuery();

//   if (userQuery.data?.viewPermissions?.includes(viewName)) {
//     return children;
//   } else {
//     return fallback ?? null;
//   }
// }
